import { render } from "./full-image-banner.vue?vue&type=template&id=b3331b4e"
import script from "./full-image-banner.vue?vue&type=script&lang=js"
export * from "./full-image-banner.vue?vue&type=script&lang=js"

import "./full-image-banner.vue?vue&type=style&index=0&id=b3331b4e&lang=scss"

import exportComponent from "/Users/riccardosirchia/Projects/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__